module.exports = __webpack_public_path__ + "img/menu-approval.a9368367.svg";